import { useState } from "react";
import I from "./Icon";
import  BC from "./Breadcrumb"

export default function UploadExcel({ title, columns, onBack, onSuccess }) {
  const [step,setStep] = useState(1);
  return (
    <>
      <BC items={[title]} onBack={onBack}/>
      <div className="card cp" style={{maxWidth:560}}>
        <div style={{fontWeight:700,fontSize:15,marginBottom:18}}>{title}</div>
        {step===1 ? (
          <>
            <div className="uz" onClick={()=>setStep(2)}>
              <div style={{fontSize:32,marginBottom:10}}>📊</div>
              <div style={{fontWeight:700,fontSize:13.5,marginBottom:4}}>Drag & drop Excel / CSV file</div>
              <div style={{fontSize:12,color:"var(--t3)",marginBottom:14}}>Supports .xlsx .xls .csv — max 10 MB</div>
              <button className="btn btn-p" style={{margin:"0 auto"}} onClick={e=>{e.stopPropagation();setStep(2);}}><I n="upload" s={13} c="#fff"/> Choose File</button>
            </div>
            <div style={{marginTop:14,padding:"11px 13px",background:"var(--bg)",borderRadius:"var(--r2)",border:"1px solid var(--bd)"}}>
              <div style={{fontWeight:600,fontSize:12,marginBottom:7,display:"flex",gap:5,alignItems:"center"}}><I n="file" s={13} c="var(--p)"/> Required Columns</div>
              <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>{columns.map(c=><span key={c} className="tc">{c}</span>)}</div>
              <button className="btn btn-g btn-sm" style={{marginTop:8}}><I n="download" s={11}/> Template</button>
            </div>
          </>
        ) : (
          <>
            <div style={{display:"flex",alignItems:"center",gap:9,padding:"10px 13px",background:"var(--gl)",borderRadius:"var(--r3)",marginBottom:14}}>
              <I n="check" s={14} c="var(--gd)"/><span style={{fontWeight:600,color:"var(--gd)",fontSize:12.5}}>File ready: import_data.xlsx</span>
            </div>
            <div style={{background:"var(--bg)",borderRadius:"var(--r2)",border:"1px solid var(--bd)",overflow:"hidden",marginBottom:14}}>
              <div style={{display:"flex",gap:5,padding:"7px 12px",background:"var(--bd)"}}>
                {columns.map(c=><span key={c} style={{flex:1,fontSize:9.5,fontWeight:700,color:"var(--t2)",textTransform:"uppercase"}}>{c}</span>)}
              </div>
              {[0,1].map(i=>(
                <div key={i} style={{display:"flex",gap:5,padding:"7px 12px",borderTop:"1px solid var(--bd)"}}>
                  {columns.map((_,j)=><span key={j} style={{flex:1,fontSize:11,color:"var(--t2)"}}>Sample {j+1}</span>)}
                </div>
              ))}
            </div>
            <div style={{display:"flex",gap:8}}>
              <button className="btn btn-p" onClick={onSuccess}><I n="check" s={13} c="#fff"/> Import Now</button>
              <button className="btn btn-g" onClick={()=>setStep(1)}>Re-upload</button>
              <button className="btn btn-g" onClick={onBack}>Cancel</button>
            </div>
          </>
        )}
      </div>
    </>
  );
}